import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http'

@Injectable({
  providedIn: 'root'
})
export class ForexService {

  urlCurrency ='https://www.alphavantage.co/query?function=CURRENCY_EXCHANGE_RATE'
  urlBeg = 'https://www.alphavantage.co/query?function=SYMBOL_SEARCH&keywords='
  urlEnd = '&apikey=UUAJOWGOABNZ7ZE8'
  //go to www.alphavantage.co to get your free api key
  dailyBeg = 'https://www.alphavantage.co/query?outputsize=full&function=TIME_SERIES_DAILY&symbol='
  constructor(private http: HttpClient) { }

  getCurrencyRate(currency_from: string, currency_to: string) {
    return this.http.get<any[]>(`${this.urlCurrency}&from_currency=${currency_from}&to_currency=${currency_to}${this.urlEnd}`)
  }

  search(symbol:string): Observable<any[]>{
    return this.http.get<any[]>(`${this.urlBeg}${symbol}${this.urlEnd}`)
  }

  daily(symbol:string): Observable<any[]>{
    return this.http.get<any[]>(`${this.dailyBeg}${symbol}${this.urlEnd}`)
  }

}
